import { I18nLegacy } from "@silvertours/front-legacy-shared";
import { LandingPage as DELandingPage } from "./de";
import { LandingPage as FRLandingPage } from "./fr";
var localizedComponents = {
    de: DELandingPage,
    fr: FRLandingPage
};
var useLocalizedLandingPage = function() {
    var language = I18nLegacy.useLocale().language;
    if (!Object.keys(localizedComponents).includes(language)) {
        /** @todo: this is an error, we should log it as high priority if it occurs */ return null;
    }
    return localizedComponents[language];
};
export { useLocalizedLandingPage };
